//Global keys
let locales = {
    "announcementsContractManage_menu": "Accettazione cliente",
};

export default locales;